import { render, staticRenderFns } from "./VsInfo.vue?vue&type=template&id=097e04c8&scoped=true"
import script from "./VsInfo.vue?vue&type=script&lang=js"
export * from "./VsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097e04c8",
  null
  
)

export default component.exports